import {on_window_load} from 'lib/utilities';

import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Lib
import DetectBreakpoints from 'lib/detect-breakpoints';
import DetectTouchDevice from 'lib/detect-touch-device';
import ScrollAnimations from 'lib/animation/scroll-animations';
import LazySvgLoader from 'lib/lazy-svg-loader';
import MobileFriendlyHeight from 'lib/mobile-friendly-height';
import AutoFontSize from 'lib/auto-font-size';

// Init App
import init_internet_explorer from 'app/init-internet-explorer';
import init_object_fit_polyfill from 'app/init-object-fit-polyfill';
import init_feather_icon from 'app/init-feather-icon';
import init_scroll_animations from 'app/init-scroll-animations';
import init_map from 'app/init-map';
import init_navbar from 'app/init-navbar';
import init_collapsible from 'app/init-collapsible';
import home_swiper from 'app/home-swiper';
import banner_swiper from 'app/banner-swiper';
import slide_cards from 'app/slide-cards';
import video_player from 'app/video-player';
import gallery from 'app/gallery';

console.log('App loaded');

// Init Modules
const breakpoints = DetectBreakpoints();
const detectTouchDevice = DetectTouchDevice();
const mobileFriendlyHeight = new MobileFriendlyHeight();
const scrollAnimations = new ScrollAnimations();
const lazySvgLoader = new LazySvgLoader();
const autoFontSize = new AutoFontSize('p a');

const app = {
    breakpoints,
    mobileFriendlyHeight,
    detectTouchDevice,
    scrollAnimations,
    lazySvgLoader,
    autoFontSize,
};

export type App = typeof app;

window.App = app;

init_internet_explorer();
init_object_fit_polyfill();
init_feather_icon();
init_scroll_animations();
init_map();
init_navbar();
init_collapsible();

home_swiper();
banner_swiper();
slide_cards();
video_player();
gallery();

scrollAnimations.on('resize', () => {
    autoFontSize.resize();
})

on_window_load().then(() => {
    lazySvgLoader.load();
    autoFontSize.resize();
});
